function listenerGlobalEvents(type, selector, callback) {
  document.addEventListener("click", (e) => {
    if (e.target.matches(selector)) callback(e);
  });
}

let all_products_emotive = document.querySelectorAll(
  ".product__title_with_emotive"
);

all_products_emotive.forEach((cc) => {
  let numCounts = cc.getAttribute("data-number-count");
  let titleText = cc.innerHTML;
  let updated_text = titleText.trim().split(" ");
  let productEmotive = updated_text.splice(0, +numCounts);

  if (numCounts == "") {
    cc.innerHTML = `<span class='product_emotive'><span class='rest_title'>${updated_text.join(
      " "
    )}</span>`;
  } else {
    cc.innerHTML = `<span class='product_emotive'>${productEmotive.join(
      " "
    )}</span> <br> <span class='rest_title'>${updated_text.join(" ")}</span>`;
  }
});

// this code not run on product page its only for collection and other pages
// single variants snippets js
window.addEventListener("DOMContentLoaded", function () {
  const swatch_selected_all = document.querySelectorAll(".swatch-div-box");
  swatch_selected_all.forEach((cc) => {
    cc.addEventListener("click", function (e) {
      swatch_selected_all.forEach((ccs) =>
        ccs
          .querySelector(".swatch-box-span")
          .classList.remove("swatch-div-box-border")
      );
      cc.querySelector(".swatch-box-span").classList.add(
        "swatch-div-box-border"
      );
      let data_swatch_available = e.target.getAttribute(
        "data-swatch-available"
      );

      //           set data in button
      //           cc.parentNode.parentNode.querySelector('.single-variants-atc-btn .selected_shade_name').innerHTML = cc.getAttribute('data-swatch-name');
      cc.parentNode.parentNode.querySelector(
        ".selected_shade_name"
      ).innerHTML = cc.getAttribute("data-swatch-name-show");
      cc.parentNode.parentNode.querySelector(
        ".add-to-cart-button .selected_shade_price"
      ).innerHTML = cc.getAttribute("data-swatch-price");

      var qsPrice = cc.closest('.add_to_cart').querySelector(
        ".quick-shop-atc-wrapper .selected_shade_price"
      );
      if (qsPrice) {
        qsPrice.innerHTML = cc.getAttribute("data-swatch-price");
      }


      if (
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .selected_shade_btn_name2"
        ) != null
      ) {
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .selected_shade_btn_name2"
        ).innerHTML = cc.getAttribute("data-swatch-price");
      }
      cc.parentNode.parentNode.querySelector(
        '.add-to-cart-button [name="id"]'
      ).value = cc.getAttribute("data-swatch-vid");
      // product image update..
      const productImgs = cc.closest(".card-boxs")?.querySelector(".product__imgs_updates");
      const mainImg = productImgs?.querySelector(".main_product_img");
      const hoverImg = productImgs?.querySelector(".main_product_hover_img");
      const slider = productImgs?.querySelector(".card-product-slider");

      if (mainImg) {
        mainImg.setAttribute("srcset", cc.getAttribute("data-swatch-featured"));
      }
      if (hoverImg) {
        hoverImg.setAttribute("srcset", cc.getAttribute("data-swatch-hover-img"));
      }
      if (slider) {
        slider.scrollLeft = 0;
        productImgs.querySelectorAll(".slider-dot").forEach((dot, index) => {
          dot.classList.toggle("active", index === 0);
        });
      }

      // url update
      //           cc.closest('.card__information').querySelectorAll('.card__heading a')[0].setAttribute('href', cc.getAttribute('data-swatch-url'));
      //           cc.closest('.card__information').querySelectorAll('.card__heading a')[1].setAttribute('href', cc.getAttribute('data-swatch-url'));
      let currentUrl = "";
      // if(data_swatch_available === "true"){
      currentUrl = cc.getAttribute("data-swatch-url");
      // }else{
      //   currentUrl = `${cc.getAttribute('data-swatch-url')}?notified=true`;
      // }
      console.log(currentUrl);
      cc.closest(".card-boxs")
        .querySelector(".card__inner")
        .setAttribute("onclick", `location.href='${currentUrl}';`);
      cc.closest(".card-boxs")
        .querySelector(".product__imgs_updates")
        .setAttribute("onclick", `location.href='${currentUrl}';`);
      let update_urls = cc
        .closest(".card__information")
        .querySelectorAll(".card__heading a");
      update_urls.forEach((ccs) => ccs.setAttribute("href", currentUrl));
      let update_urls_h5 = cc
        .closest(".card__information")
        .querySelectorAll(".card__heading a");
      update_urls_h5.forEach((ccs) => ccs.setAttribute("href", currentUrl));
      let shopAtTargetUrl = cc.getAttribute("data-shop_at_target");
      let shopAtWalmartUrl = cc.getAttribute("data-shop_at_walmart");
      let shopAtAmazonUrl = cc.getAttribute("data-shop_at_amazon");
      //           cc.closest('.card__information').querySelectorAll('.card__heading.h5 a')[0].setAttribute('href', cc.getAttribute('data-swatch-url'));
      //           cc.closest('.card__information').querySelectorAll('.card__heading.h5 a')[1].setAttribute('href', cc.getAttribute('data-swatch-url'));
      //           button update..
      if (data_swatch_available === "true") {
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .classList.add("pw-btn");
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).innerHTML = "Add To Cart";
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).style.color = "rgb(35, 31, 32)";
        // cc.parentNode.parentNode.querySelector('.add-to-cart-button .single-variants-atc-btn').removeEventListener('click', fun);
      } else if (data_swatch_available === "coming_soon") {
        /* ################# Remove After new item launch ############### */
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .classList.remove("pw-btn");
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).innerHTML = "Coming Soon";
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).style.color = "#D10000";
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).style.width = "55px";
      } else if (data_swatch_available === "false" && shopAtTargetUrl !== "") {
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .classList.remove("pw-btn");
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).innerHTML = "Shop At Target";
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).style.color = "#D10000";
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .addEventListener(
            "click",
            (fun = () => {
              window.location.href = shopAtTargetUrl;
            })
          );
      } else if (data_swatch_available === "false" && shopAtWalmartUrl !== "") {
        console.log("inside of the ShopAtWalmartURl");
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .classList.remove("pw-btn");
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).innerHTML = "Shop At Walmart";
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).style.color = "#D10000";
        cc.parentNode.parentNode
          .querySelector(
            ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
          )
          .classList.add("walmart_text");
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .addEventListener(
            "click",
            (fun = () => {
              window.location.href = shopAtWalmartUrl;
            })
          );
      } else if (data_swatch_available === "false" && shopAtAmazonUrl !== "") {
        console.log("inside of the shopAtAmazonUrl");
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .classList.remove("pw-btn");
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).innerHTML = "Shop At Amazon";
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).style.color = "#D10000";
        cc.parentNode.parentNode
          .querySelector(
            ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
          )
          .classList.add("amazon_text");
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .addEventListener(
            "click",
            (fun = () => {
              window.location.href = shopAtAmazonUrl;
            })
          );
      } else {
        /* ########################## */
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .classList.remove("pw-btn");
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).innerHTML = "Sold Out";
        cc.parentNode.parentNode.querySelector(
          ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
        ).style.color = "#D10000";
        cc.parentNode.parentNode
          .querySelector(
            ".add-to-cart-button .single-variants-atc-btn .atc-btn-text"
          )
          .classList.remove("walmart_text");
        cc.parentNode.parentNode
          .querySelector(".add-to-cart-button .single-variants-atc-btn")
          .addEventListener(
            "click",
            (fun = () => {
              let url = cc.getAttribute("data-swatch-url");
              if (url.indexOf("?") > -1) {
                url = url + "&notified=true";
              } else {
                url = url + "?notified=true";
              }
              window.location.href = url;
            })
          );
      }
      // Black Friday 2023
      let blackFridayBadgeText = cc.getAttribute("data-black_friday_badge");
      if (blackFridayBadgeText != "") {
        console.log(cc);
        cc
          .closest(".card-wrapper")
          .querySelector(
            ".blackFridayBadge"
          ).innerHTML = `<p>${blackFridayBadgeText}</p>`;
      } else {
        cc
          .closest(".card-wrapper")
          .querySelector(".blackFridayBadge").innerHTML = ``;
      }
      // let closestCardInner = cc.closest(".card-wrapper");

      // console.log(`blackFridayBadgeText - ${blackFridayBadgeText}`);
      // console.log(`closestCardInner - ${closestCardInner}`);
      // if (closestCardInner) {
      //   let blackFridayBadge =
      //     closestCardInner.querySelector(".blackFridayBadge");
      //   if (blackFridayBadge) {
      //     blackFridayBadge.innerHTML = `<span>${blackFridayBadgeText}</span>`;
      //   } else {
      //     // .blackFridayBadge not found within the closest .card__inner
      //   }
      // } else {
      //   // No .card__inner found in the ancestor chain
      // }
      // Black Friday 2023

      // Custom Badge 2023
      let customBadgeText = cc.getAttribute("data-custom_badge");
      if (customBadgeText != "") {
        console.log(cc);
        cc
          .closest(".card-wrapper")
          .querySelector(
            ".rightTopBadge"
          ).innerHTML = `<p>${customBadgeText}</p>`;
      } else {
        cc
          .closest(".card-wrapper")
          .querySelector(".rightTopBadge").innerHTML = ``;
      }
    });
  });

  const shade_child_count_val = document.querySelectorAll(
    ".add_to_cart.desktop .shade_child_count"
  );
  if (shade_child_count_val == null) return;
  shade_child_count_val.forEach((cc) => {
    let set_arrow_showcase = cc.childElementCount;
    if (window.screen.width < 480) {
      if (set_arrow_showcase <= 5) {
        cc.nextElementSibling.style.display = "none";
      }
    } else if (window.screen.width < 500) {
      if (set_arrow_showcase < 7) {
        cc.nextElementSibling.style.display = "none";
      }
    } else {
      if (set_arrow_showcase < 10) {
        cc.nextElementSibling.style.display = "none";
      }
    }
  });
});

const slider = document.querySelectorAll(".inner-variants");
slider.forEach((cc) => {
  let isDown = false;
  let startX;
  let scrollLeft;
  cc.addEventListener("mousedown", (e) => {
    isDown = true;
    cc.classList.add("active");
    startX = e.pageX - cc.offsetLeft;
    scrollLeft = cc.scrollLeft;
  });
  cc.addEventListener("mouseleave", () => {
    isDown = false;
    cc.classList.remove("active");
  });
  cc.addEventListener("mouseup", () => {
    isDown = false;
    cc.classList.remove("active");
  });
  cc.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - cc.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    cc.scrollLeft = scrollLeft - walk;
    // console.log(walk);
  });
});

// scroll bar arrow click then scroll left and right side
const shade_arrows = document.querySelectorAll(".shade-arrow");
shade_arrows.forEach((cc) => {
  cc.addEventListener("click", function () {
    slide(cc);
  });
});

function slide(cc) {
  let direction = cc.getAttribute("data-direction");
  let container = cc.parentElement.querySelector(".inner-variants");
  let left_side_arrow = cc.parentElement.querySelector(".shade-arrow-left");
  cc.parentElement.classList.add("active-arrow-left");
  container.cssText = `
	  padding-left: 6px;
      width: calc(95%);
      margin: 0 auto;`;

  left_side_arrow.style.display = "block";
  scrollCompleted = 0;
  let slideVar = setInterval(function () {
    if (direction == "left") {
      container.scrollLeft -= 10;
    } else {
      container.scrollLeft += 10;
    }
    scrollCompleted += 10;
    if (scrollCompleted >= 100) {
      window.clearInterval(slideVar);
    }
  }, 50);
}

// Video Circles autoplay
function initializeVideoCircles() {
  console.log("hi Video Circles")
  // Find all video circles sections and only work with the visible one
  let videoCirclesSections = document.querySelectorAll(
    ".variant-videos-circles"
  );
  let activeSection = Array.from(videoCirclesSections).find(
    (section) => section.style.display !== "none"
  );

  // If no active section is found, do nothing
  if (!activeSection) {
    return;
  }

  let videoContainers = activeSection.querySelectorAll(".video-container");
  let videos = activeSection.querySelectorAll("video");
  let modal = document.getElementById("videoModal");
  let modalVideo = document.getElementById("modalVideo");
  let currentVideo = 0;

  // ponytail: no videos / containers = skip (stops getComputedStyle(null) spam on PDP)
  if (!videoContainers.length || !videos.length) {
    return;
  }

  function playNextVideo() {
    // Make sure the current video is still visible before trying to play the next one
    if (!videoContainers[currentVideo] || !videos[currentVideo]) return;
    if (getComputedStyle(videoContainers[currentVideo]).display !== "none") {
      videos[currentVideo].load();
      currentVideo = (currentVideo + 1) % videos.length;
      if (!videos[currentVideo] || !videoContainers[currentVideo]) return;
      videos[currentVideo].play();
      videoContainers[currentVideo].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }

  // Start playing the first video if it's visible
  if (getComputedStyle(videoContainers[currentVideo]).display !== "none") {
    videos[currentVideo].play();
    videoContainers[currentVideo].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }

  videos.forEach((video, index) => {
    video.addEventListener("ended", playNextVideo);
    video.addEventListener("click", () => {
      if (!videoContainers[index] || !modal || !modalVideo) return;
      if (getComputedStyle(videoContainers[index]).display !== "none") {
        modal.style.display = "block";
        modalVideo.src = videos[index].querySelector("source").src;
        modalVideo.load();
        modalVideo.play();
      }
    });
  });

  let closeModalBtn = document.querySelector(".close-modal");
  if (closeModalBtn && modal && modalVideo) {
    closeModalBtn.addEventListener("click", () => {
      modal.style.display = "none";
      modalVideo.pause();
    });
  }

  window.addEventListener("click", (event) => {
    if (event.target == modal && modal && modalVideo) {
      modal.style.display = "none";
      modalVideo.pause();
    }
  });
}

// Initialization on DOMContentLoaded
document.addEventListener("DOMContentLoaded", (event) => {
  initializeVideoCircles();
});

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.querySelectorAll(".desktop .inner-variants").forEach((parent) => {
      const availableChildren = parent.querySelectorAll(".swatch-div-box");

      for (let child of availableChildren) {
        if (child.getAttribute("data-swatch-available") === "true") {
          child.click();
          break; // Stop after clicking the first available child
        }
      }
    });
  }, 500); // Run after 0.5 seconds
});
